import { v4 as uuidv4 } from 'uuid';

export const CONTACT_INFO_TYPE = 'contact-info';

export const CONTACT_EXTRA_FIELD_OPTIONS = [
	{ type: 'landline', label: '座机' },
	{ type: 'email', label: '邮箱' },
	{ type: 'website', label: '网址' },
	{ type: 'fax', label: '传真' },
	{ type: 'wechat', label: '微信' },
	{ type: 'qq', label: 'QQ' },
	{ type: 'weibo', label: '微博' },
	{ type: 'company', label: '公司' },
];

export const CONTACT_FIELD_META = {
	phone: { icon: 'PhoneOutlined', action: 'call', actionLabel: '拨打' },
	landline: { icon: 'PhoneOutlined', action: 'call', actionLabel: '拨打' },
	email: { icon: 'MailOutlined', action: 'copy', actionLabel: '复制' },
	address: { icon: 'EnvironmentOutlined', action: 'map', actionLabel: '地图' },
	website: { icon: 'LinkOutlined', action: 'copy', actionLabel: '复制' },
	fax: { icon: 'PrinterOutlined', action: 'copy', actionLabel: '复制' },
	wechat: { icon: 'WechatOutlined', action: 'copy', actionLabel: '复制' },
	qq: { icon: 'QqOutlined', action: 'copy', actionLabel: '复制' },
	weibo: { icon: 'WeiboOutlined', action: 'copy', actionLabel: '复制' },
	company: { icon: 'BankOutlined', action: 'copy', actionLabel: '复制' },
};

export function getContactFieldMeta(type) {
	return CONTACT_FIELD_META[type] || CONTACT_FIELD_META.company;
}

export function getContactExtraFieldLabel(type) {
	return CONTACT_EXTRA_FIELD_OPTIONS.find(item => item.type === type)?.label || '信息';
}

export function getContactInfoDefaults(extra = {}) {
	return normalizeContactInfoData({
		title: '',
		phones: [''],
		email: '',
		address: '',
		extraItems: [],
		remark: '',
		...extra,
	});
}

export function normalizeContactInfoData(data = {}) {
	const phones = Array.isArray(data.phones)
		? data.phones.map(phone => String(phone || '').trim())
		: [''];
	const extraItems = (data.extraItems || []).map((item) => ({
		id: item.id || uuidv4(),
		type: item.type || 'company',
		value: String(item.value || '').trim(),
	}));
	const address = String(data.address || '').trim();

	return {
		title: String(data.title || '').trim(),
		phones: phones.length ? phones : [''],
		email: String(data.email || '').trim(),
		address,
		extraItems,
		remark: String(data.remark || '').trim(),
	};
}

export function getContactDisplayRows(data = {}) {
	const normalized = normalizeContactInfoData(data);
	const rows = [];

	normalized.phones.filter(Boolean).forEach((value, index) => {
		rows.push({ id: `phone-${index}-${value}`, type: 'phone', value });
	});

	if (normalized.email) {
		rows.push({ id: 'email', type: 'email', value: normalized.email });
	}

	if (normalized.address) {
		rows.push({
			id: 'address',
			type: 'address',
			value: normalized.address,
		});
	}

	normalized.extraItems.filter(item => item.value).forEach((item) => {
		rows.push({
			id: item.id,
			type: item.type,
			value: item.value,
		});
	});

	return {
		...normalized,
		rows,
		hasContent: Boolean(normalized.title || rows.length || normalized.remark),
	};
}

export function isContactInfoBlock(type) {
	return type === CONTACT_INFO_TYPE;
}
